import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";

// ✅ Save token in cookie
export const saveToken = ({token, refreshToken}) => {
  try {
    console.log('tokens', token, refreshToken)
    Cookies.set("token", token, {
      expires: 7,          // Expires in 7 days
      secure: true,        // Works only over HTTPS
      sameSite: "strict",  // Prevent CSRF attacks
      path: "/",           // Accessible site-wide
    });

    Cookies.set("refreshToken", refreshToken, {
      expires: 7,          // Expires in 7 days
      secure: true,        // Works only over HTTPS
      sameSite: "strict",  // Prevent CSRF attacks
      path: "/",           // Accessible site-wide
    });
  } catch (error) {
    console.log("Error in saveToken:", error);
  }
};

// ✅ Get token from cookie
export const getToken = (key) => {
  try {
    const token = Cookies.get(key);
    console.log("Token:", token);
    return token;
  } catch (error) {
    console.log("Error in getToken:", error);
    return null;
  }
};

// ✅ Decode token payload (from cookie)
export const getTokenPayload = (key) => {
  try {
    const token = getToken(key); // get from cookie
    const payload = token ? jwt_decode(token) : {};
    console.log("Payload:", payload);
    return payload;
  } catch (error) {
    console.log("Error in getTokenPayload:", error);
    return {};
  }
};

// ✅ Remove token from cookie
export const removeToken = () => {
  try {
    Cookies.remove("token");
    console.log("Token removed");
  } catch (error) {
    console.log("Error in removeToken:", error);
  }
};
